import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { FiMenuMultiSelectItemSearchComponent } from './fi-menu-multi-select-item-search.component';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { FiProfileIconModule } from '@fi-shared/profile-icon/profile-icon.module';
import { MatOptionModule } from '@angular/material/core';
import { CdkFixedSizeVirtualScroll, CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { FiWhenScrolledModule } from '@fi-shared/fi-directives/when-scrolled/when-scrolled.module';
import { FiWrapperTableModule } from '@fi-shared/fi-wrapper-table/fi-wrapper-table.module';
import { FiConnectedDropdownItemsModule } from '@fi-shared/fi-connected-dropdown-items/fi-connected-dropdown-items.module';
import { FiMenuMultiSelectItemSearchHelperService } from '@fi-shared/fi-menu-multi-select-item-search/fi-menu-multi-select-item-search-helper.service';

@NgModule({
    declarations: [FiMenuMultiSelectItemSearchComponent],
    providers: [FiMenuMultiSelectItemSearchHelperService],
    exports: [FiMenuMultiSelectItemSearchComponent],
    imports: [
        BrowserModule,
        FormsModule,
        CommonModule,
        MatFormFieldModule,
        MatInputModule,
        MatMenuModule,
        FiAppTextSharedModule,
        MatCheckboxModule,
        MatDividerModule,
        MatIconModule,
        FiProfileIconModule,
        MatOptionModule,
        CdkFixedSizeVirtualScroll,
        CdkVirtualScrollViewport,
        FiWhenScrolledModule,
        FiWrapperTableModule,
        FiConnectedDropdownItemsModule,
    ],
})
export class FiMenuMultiSelectItemSearchModule {}
